<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary {{ sectionclass }}">
		<!-- style="background: #cdcdcd !important; height: 100%;" -->
		<div *ngIf="hasLiftData; else noLiftDataBlock">
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header primary-color-bg"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="date-range-banner" *ngIf="showDateRangeBanner">
				<div class="banner-content">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
						style="margin-right: 8px; flex-shrink: 0"
					>
						<path
							d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
							fill="#00AAFF"
						/>
						<path
							d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
							fill="#00AAFF"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
							fill="#00AAFF"
						/>
					</svg>
					<div class="banner-text">
						Some lift values may be skewed due to historical data limits (only past 2 years + 1 quarter available)
					</div>
				</div>
			</div>
			<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content stats_content">
				<div class="overall-text">Overall</div>
				<div class="o-stack o-stack--center lift_stats lift_icons">
					<!--  style="text-align: center"-->
					<div class="text_align_center">
						<svg
							class="lift-icons"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							width="100"
							height="70"
							viewBox="0 0 69 50"
						>
							<defs>
								<path id="prefix__a" d="M0 0.042L11.966 0.042 11.966 20.929 0 20.929z" />
								<path id="prefix__c" d="M0 0.049L6.965 0.049 6.965 9 0 9z" />
							</defs>
							<g fill="none" fill-rule="evenodd">
								<path
									class="primary-svg-fill"
									d="M24 1h12c1.105 0 2 .895 2 2v40c0 1.105-.895 2-2 2H24c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2zM2 23h12c1.105 0 2 .895 2 2v18c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V25c0-1.105.895-2 2-2z"
									transform="translate(16 3)"
								/>
								<g transform="translate(16 3) translate(1)">
									<mask id="prefix__b" fill="#fff">
										<use xlink:href="#prefix__a" />
									</mask>
									<path
										class="secondary-svg-fill"
										d="M3.63 20.93c-.225 0-.441-.186-.441-.414V9.195H.914c-.754 0-1.153-.749-.761-1.32L5.218.47c.395-.572 1.126-.574 1.529.01l5.065 7.376c.401.586-.029 1.339-.76 1.339H8.393v1.68c0 .23-.172.414-.397.414-.224 0-.397-.185-.397-.413V8.81c0-.228.11-.423.335-.423h3.116c.067 0 .098-.025.102-.035L6.082.994C6.049.947 5.929.922 5.884.988L.819 8.35c-.004.01.024.037.095.037h2.688c.224 0 .469.195.469.423v11.706c0 .228-.217.413-.441.413"
										mask="url(#prefix__b)"
									/>
								</g>
								<g transform="translate(16 3) translate(7 12)">
									<path
										class="secondary-svg-fill"
										d="M2 .923C1.406.923.923 1.406.923 2S1.406 3.077 2 3.077 3.077 2.594 3.077 2 2.594.923 2 .923M2 4C.897 4 0 3.103 0 2s.897-2 2-2 2 .897 2 2-.897 2-2 2M5 5.923c-.594 0-1.077.483-1.077 1.077S4.406 8.077 5 8.077 6.077 7.594 6.077 7 5.594 5.923 5 5.923M5 9c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
									/>
									<mask id="prefix__d" fill="#fff">
										<use xlink:href="#prefix__c" />
									</mask>
									<path
										class="secondary-svg-fill"
										d="M.162 8.905c-.184-.15-.216-.427-.07-.619L6.207.216c.145-.19.41-.223.595-.073.184.151.216.428.07.62L.758 8.832c-.144.19-.41.224-.595.072"
										mask="url(#prefix__d)"
									/>
								</g>
							</g>
						</svg>
						<svg
							class="r702-lift-icons"
							width="40"
							height="40"
							viewBox="0 0 40 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M21.3824 31.3772C21.4002 31.2667 21.4084 31.1549 21.407 31.043L21.407 11.995L21.5989 12.4104C21.7897 12.8164 22.0495 13.1857 22.3664 13.5019L27.6721 18.8434C28.3392 19.5469 29.4122 19.6651 30.2146 19.1235C31.0697 18.4932 31.2553 17.2844 30.6292 16.4235C30.5786 16.354 30.5234 16.2879 30.4641 16.2258L20.8697 6.56659C20.1207 5.81172 18.9058 5.81106 18.156 6.56508L8.56013 16.2258C7.81183 16.9812 7.8135 18.2044 8.5639 18.9578C8.62297 19.0171 8.68581 19.0725 8.75201 19.1235C9.5544 19.6651 10.6275 19.5469 11.2945 18.8434L16.6098 13.5115C16.8916 13.2281 17.128 12.9022 17.3102 12.5456L17.5692 11.9661L17.5692 30.9367C17.5328 31.9236 18.2176 32.7894 19.1811 32.9748C20.2272 33.1456 21.2127 32.4303 21.3824 31.3772Z"
								fill="#333333"
							/>
						</svg>
					</div>
					<div class="text_align_center">
						<svg
							class="lift-icons"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							width="95"
							height="50"
							viewBox="0 0 95 50"
						>
							<defs>
								<path id="a" d="M0 .053h55.942v32.864H0z" />
							</defs>
							<g fill="none" fill-rule="evenodd">
								<path
									class="primary-svg-fill"
									d="M26.883 32.25c-1.068-1.72-1.668-3.536-1.822-5.25a6.873 6.873 0 0 0-.955 4.865c.708 3.993 4.758 6.695 9.046 6.036a8.48 8.48 0 0 0 .848-.175c-2.666-.665-5.339-2.613-7.117-5.476M69.117 32.25c1.068-1.72 1.668-3.536 1.822-5.25a6.873 6.873 0 0 1 .955 4.865c-.708 3.993-4.758 6.695-9.046 6.036a8.49 8.49 0 0 1-.848-.175c2.666-.665 5.339-2.613 7.117-5.476"
								/>
								<g transform="translate(20 9)">
									<mask id="b" fill="#fff">
										<use xlink:href="#a" />
									</mask>
									<path
										class="primary-svg-fill"
										d="M43.766 30.002c-5.182 0-9.398-4.228-9.398-9.425 0-5.197 4.216-9.425 9.398-9.425 5.181 0 9.397 4.228 9.397 9.425 0 5.197-4.216 9.425-9.397 9.425m-17.248-9.425c0-.803.652-1.457 1.453-1.457a1.457 1.457 0 0 1 0 2.914 1.457 1.457 0 0 1-1.453-1.457m-14.342 9.425c-5.181 0-9.397-4.228-9.397-9.425 0-5.197 4.216-9.425 9.397-9.425 5.182 0 9.398 4.228 9.398 9.425 0 5.197-4.216 9.425-9.398 9.425M51.82 11.456c-1.28-1.698-3.596-4.532-5.712-5.865 0 0-1.275-.986-3.534-1.242 0 0-3.533-6.503-8.595-3.507 0 0-3.825 1.68-1.93 7.525 0 0-.748 1.096-.912 1.617 0 0-1.145-1.97-3.164-1.973h-.002-.002c-2.019.003-3.165 1.973-3.165 1.973-.164-.52-.91-1.617-.91-1.617 1.894-5.845-1.93-7.525-1.93-7.525-5.063-2.996-8.597 3.507-8.597 3.507-2.258.256-3.533 1.242-3.533 1.242-2.116 1.333-4.432 4.167-5.712 5.865A12.26 12.26 0 0 0 0 20.642c0 6.78 5.48 12.275 12.238 12.275 6.088 0 11.137-4.46 12.08-10.298a4.15 4.15 0 0 0 3.65 2.187h.005a4.15 4.15 0 0 0 3.651-2.187c.943 5.839 5.992 10.298 12.08 10.298 6.759 0 12.238-5.496 12.238-12.275a12.26 12.26 0 0 0-4.122-9.186"
										mask="url(#b)"
									/>
								</g>
							</g>
						</svg>
						<svg
							class="r702-lift-icons"
							width="40"
							height="40"
							viewBox="0 0 40 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M19.375 24.6208H18.4375C17.92 24.6208 17.5 24.2063 17.5 23.6955V18.1432C17.5 17.6324 17.92 17.2178 18.4375 17.2178H19.375C21.4425 17.2178 23.125 18.8786 23.125 20.9193C23.125 22.9601 21.4425 24.6208 19.375 24.6208ZM19.375 19.0686V22.7701C20.4087 22.7701 21.25 21.9397 21.25 20.9193C21.25 19.899 20.4087 19.0686 19.375 19.0686Z"
								fill="#333333"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M13.125 23.6955C13.125 24.2063 13.545 24.6208 14.0625 24.6208C14.58 24.6208 15 24.2063 15 23.6955V19.6855C15 18.3246 13.8787 17.2178 12.5 17.2178C11.1212 17.2178 10 18.3246 10 19.6855V23.6955C10 24.2063 10.42 24.6208 10.9375 24.6208C11.455 24.6208 11.875 24.2063 11.875 23.6955V22.7701H13.125V23.6955ZM13.125 19.6855V20.9193H11.875V19.6855C11.875 19.345 12.155 19.0686 12.5 19.0686C12.845 19.0686 13.125 19.345 13.125 19.6855Z"
								fill="#333333"
							/>
							<path
								d="M25.9375 24.6208H27.76C28.995 24.6208 30.0012 23.5832 30.0012 22.3074C30.0012 21.0316 28.9962 19.994 27.7612 19.994H27.24C27.0412 19.994 26.875 19.7817 26.875 19.5313C26.875 19.2808 27.0425 19.0686 27.24 19.0686H29.0625C29.58 19.0686 30 18.654 30 18.1432C30 17.6324 29.58 17.2178 29.0625 17.2178H27.24C26.005 17.2178 24.9987 18.2555 24.9987 19.5313C24.9987 20.8071 26.0037 21.8447 27.2387 21.8447H27.76C27.9587 21.8447 28.125 22.0569 28.125 22.3074C28.125 22.5579 27.9575 22.7701 27.76 22.7701H25.9375C25.42 22.7701 25 23.1847 25 23.6955C25 24.2063 25.42 24.6208 25.9375 24.6208Z"
								fill="#333333"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M31.5625 34H8.4375C6.54125 34 5 32.4787 5 30.6069L5 10.3931C5 8.52133 6.54125 7 8.4375 7H31.5625C33.4588 7 35 8.52133 35 10.3931V30.6069C35 32.4787 33.4588 34 31.5625 34ZM8.4375 8.85077C7.57625 8.85077 6.875 9.54296 6.875 10.3931V30.6069C6.875 31.457 7.57625 32.1492 8.4375 32.1492H31.5625C32.4237 32.1492 33.125 31.457 33.125 30.6069V10.3931C33.125 9.54296 32.4237 8.85077 31.5625 8.85077H8.4375Z"
								fill="#333333"
							/>
						</svg>
					</div>
					<div class="text_align_center">
						<svg
							class="lift-icons"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							width="90"
							height="50"
							viewBox="0 0 90 50"
						>
							<defs>
								<path id="a" d="M0 .053h55.942v32.864H0z" />
								<path id="c" d="M0 0h50v50H0z" />
							</defs>
							<g fill="none" fill-rule="evenodd">
								<path
									class="primary-svg-fill"
									d="M23.883 32.25c-1.068-1.72-1.668-3.536-1.822-5.25a6.873 6.873 0 0 0-.955 4.865c.708 3.993 4.758 6.695 9.046 6.036a8.48 8.48 0 0 0 .848-.175c-2.666-.665-5.339-2.613-7.117-5.476M66.117 32.25c1.068-1.72 1.668-3.536 1.822-5.25a6.873 6.873 0 0 1 .955 4.865c-.708 3.993-4.758 6.695-9.046 6.036a8.49 8.49 0 0 1-.848-.175c2.666-.665 5.339-2.613 7.117-5.476"
								/>
								<g transform="translate(17 9)">
									<mask id="b" fill="#fff">
										<use xlink:href="#a" />
									</mask>
									<path
										class="primary-svg-fill"
										d="M43.766 30.002c-5.182 0-9.398-4.228-9.398-9.425 0-5.197 4.216-9.425 9.398-9.425 5.181 0 9.397 4.228 9.397 9.425 0 5.197-4.216 9.425-9.397 9.425m-17.248-9.425c0-.803.652-1.457 1.453-1.457a1.457 1.457 0 0 1 0 2.914 1.457 1.457 0 0 1-1.453-1.457m-14.342 9.425c-5.181 0-9.397-4.228-9.397-9.425 0-5.197 4.216-9.425 9.397-9.425 5.182 0 9.398 4.228 9.398 9.425 0 5.197-4.216 9.425-9.398 9.425M51.82 11.456c-1.28-1.698-3.596-4.532-5.712-5.865 0 0-1.275-.986-3.534-1.242 0 0-3.533-6.503-8.595-3.507 0 0-3.825 1.68-1.93 7.525 0 0-.748 1.096-.912 1.617 0 0-1.145-1.97-3.164-1.973h-.002-.002c-2.019.003-3.165 1.973-3.165 1.973-.164-.52-.91-1.617-.91-1.617 1.894-5.845-1.93-7.525-1.93-7.525-5.063-2.996-8.597 3.507-8.597 3.507-2.258.256-3.533 1.242-3.533 1.242-2.116 1.333-4.432 4.167-5.712 5.865A12.26 12.26 0 0 0 0 20.642c0 6.78 5.48 12.275 12.238 12.275 6.088 0 11.137-4.46 12.08-10.298a4.15 4.15 0 0 0 3.65 2.187h.005a4.15 4.15 0 0 0 3.651-2.187c.943 5.839 5.992 10.298 12.08 10.298 6.759 0 12.238-5.496 12.238-12.275a12.26 12.26 0 0 0-4.122-9.186"
										mask="url(#b)"
									/>
								</g>
								<g transform="translate(20)">
									<mask id="d" fill="#fff">
										<use xlink:href="#c" />
									</mask>
									<path
										fill="#ED1C24"
										d="M4.271 25a20.721 20.721 0 0 1 1.518-7.802 20.595 20.595 0 0 1 4.554-6.855A20.595 20.595 0 0 1 21.037 4.65a20.898 20.898 0 0 1 7.926 0c1.313.254 2.604.637 3.84 1.138 1.91.774 3.674 1.82 5.268 3.12L8.91 38.07a20.506 20.506 0 0 1-3.12-5.269A20.721 20.721 0 0 1 4.27 25zm7.658 16.091L41.09 11.93a20.506 20.506 0 0 1 3.12 5.269A20.722 20.722 0 0 1 45.73 25a20.722 20.722 0 0 1-1.517 7.802 20.595 20.595 0 0 1-4.555 6.855 20.595 20.595 0 0 1-10.694 5.692 20.897 20.897 0 0 1-7.926 0 20.719 20.719 0 0 1-3.84-1.138 20.506 20.506 0 0 1-5.268-3.12zM25 50c6.398 0 12.796-2.44 17.678-7.322 9.763-9.763 9.763-25.593 0-35.356A24.922 24.922 0 0 0 25 0 24.922 24.922 0 0 0 7.322 7.322c-9.763 9.763-9.763 25.593 0 35.356A24.922 24.922 0 0 0 25 50z"
										mask="url(#d)"
									/>
								</g>
							</g>
						</svg>
						<svg
							class="r702-lift-icons"
							width="40"
							height="40"
							viewBox="0 0 40 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M5.94532 35C5.70323 35 5.46115 34.908 5.27707 34.7226C4.90764 34.3532 4.90764 33.7543 5.27707 33.3849L6.29727 32.3647C6.2728 32.1993 6.26053 32.0267 6.26053 31.8479V10.7291C6.26053 8.81638 7.81515 7.26177 9.72784 7.26177H30.8469C31.0262 7.26177 31.1988 7.27397 31.364 7.29826L32.3852 6.27707C32.7546 5.90764 33.3535 5.90764 33.7229 6.27707C34.0924 6.64649 34.0924 7.24538 33.7229 7.61481L8.0437 33.2938C8.02455 33.3147 8.0044 33.3349 7.98328 33.3542L6.61482 34.7226C6.42948 34.908 6.1874 35 5.94532 35ZM13.8087 24.8533L8.15179 30.5102V10.7291C8.15179 9.86034 8.85912 9.15302 9.72784 9.15302H29.5092L19.257 19.4051C19.4077 19.2375 19.4994 19.016 19.4994 18.7731V18.294C19.4994 17.772 19.0757 17.3484 18.5537 17.3484C18.0317 17.3484 17.6081 17.772 17.6081 18.294V18.7731C17.6081 19.2951 18.0317 19.7188 18.5537 19.7188C18.7966 19.7188 19.0181 19.6271 19.1857 19.4764L15.0864 23.5756V19.8701C15.0864 18.4794 13.9554 17.3484 12.5647 17.3484C11.174 17.3484 10.0431 18.4794 10.0431 19.8701V23.9678C10.0431 24.4897 10.4667 24.9134 10.9887 24.9134C11.5107 24.9134 11.9343 24.4897 11.9343 23.9678V23.0221H13.1952V23.9678C13.1952 24.3729 13.4504 24.7188 13.8087 24.8533ZM13.1952 19.8701V21.1309H11.9343V19.8701C11.9343 19.5221 12.218 19.2396 12.5647 19.2396C12.9115 19.2396 13.1952 19.5221 13.1952 19.8701Z"
								fill="#333333"
							/>
							<path
								d="M9.41263 35H30.5317C32.4444 35 33.9991 33.4454 33.9991 31.5327V10.4138C33.9991 9.89186 33.5754 9.46822 33.0534 9.46822C32.5314 9.46822 32.1078 9.89186 32.1078 10.4138V31.5327C32.1078 32.4014 31.4005 33.1088 30.5317 33.1088H9.41263C8.89064 33.1088 8.467 33.5324 8.467 34.0544C8.467 34.5764 8.89064 35 9.41263 35Z"
								fill="#333333"
							/>
							<path
								d="M20.1298 24.9134H19.3355C18.8135 24.9134 18.3898 24.4897 18.3898 23.9678C18.3898 23.4458 18.8135 23.0221 19.3355 23.0221H20.1298C20.6329 23.0221 21.1069 22.8254 21.4663 22.4674C21.8244 22.1093 22.0211 21.6352 22.0211 21.1309C22.0211 20.9582 22.0021 20.8069 21.9681 20.682C21.8269 20.179 22.1181 19.657 22.6225 19.5158C23.1218 19.3708 23.6475 19.6671 23.7888 20.1689C23.8707 20.4601 23.9123 20.7842 23.9123 21.1309C23.9123 22.1396 23.5189 23.0902 22.8028 23.8051C22.0866 24.52 21.1385 24.9134 20.1298 24.9134Z"
								fill="#333333"
							/>
							<path
								d="M26.1188 24.9134H27.9571C29.2028 24.9134 30.2165 23.853 30.2165 22.5493C30.2165 21.2456 29.2028 20.1853 27.9571 20.1853H27.4326C27.2334 20.1853 27.0644 19.9684 27.0644 19.7125C27.0644 19.4565 27.2334 19.2396 27.4326 19.2396H29.2709C29.7929 19.2396 30.2165 18.816 30.2165 18.294C30.2165 17.772 29.7929 17.3484 29.2709 17.3484H27.4326C26.1869 17.3484 25.1732 18.4088 25.1732 19.7125C25.1732 21.0162 26.1869 22.0765 27.4326 22.0765H27.9571C28.1563 22.0765 28.3253 22.2934 28.3253 22.5493C28.3253 22.8053 28.1563 23.0221 27.9571 23.0221H26.1188C25.5968 23.0221 25.1732 23.4458 25.1732 23.9678C25.1732 24.4897 25.5968 24.9134 26.1188 24.9134Z"
								fill="#333333"
							/>
						</svg>
					</div>
				</div>
				<div class="o-stack o-stack--center lift_stats">
					<!--  style="text-align: center"-->
					<div class="text_align_center">
						<span
							class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data primary-color"
							*ngIf="liftStatsData"
							>{{ liftStatsData.digitalLift }}x</span
						>
						<!--  style="display: block; font-size: 0.75em;"  -->
						<span class="list_stats_name">Digital Lift</span>
					</div>
					<!-- style="text-align: center" -->
					<div class="text_align_center">
						<span
							class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data primary-color"
							*ngIf="liftStatsData"
							>{{ liftStatsData.exposedRate | number : '0.2-2' }}%</span
						>
						<!-- style="display: block; font-size: 0.75em;" -->
						<span class="list_stats_name_ExpRate">Exposed Rate</span>
					</div>
					<!-- style="text-align: center" -->
					<div class="text_align_center">
						<span
							class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data primary-color"
							*ngIf="liftStatsData"
							>{{ liftStatsData.baseLineRate | number : '0.2-2' }}%</span
						>
						<!-- style="display: block; font-size: 0.75em;" -->
						<span class="list_stats_name">Baseline Rate</span>
					</div>
				</div>
				<!-- style="font-size: 1.2em; padding: 2em 0em 0.8em !important;" -->
				<div class="set_padding_r5"></div>
				<div class="content_mainCls lift_stats_subsection lift_stats_subtitle">
					People who saw your digital ads were
					<b>
						<span *ngIf="liftStatsData">{{ liftStatsData.digitalLift }}</span> times more likely to visit your website
					</b>
					than the unexposed audience
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div
					class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{
						sectionclass
					}}"
				>
					<!-- style="background: #cdcdcd !important; height: 100%;" -->
					<div>
						<div
							class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header primary-color-bg"
						>
							<div class="o-stack__cell">
								<h5>{{ sectiontitle }}</h5>
							</div>
						</div>
					</div>
				</div>
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
		<ng-template #noLiftDataBlock>
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header primary-color-bg"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="analytics-portlet-content u-px-small no_lift_data_block stats_content">
				<div class="lift_stats_subhead">Campaigns in the selected date range are not eligible for lift reporting.</div>
				<div class="lift_stats_sub_section">
					<div class="lift_stats_subhead" style="padding-top: 5px">
						A campaign must meet all of the following 3 requirements to receive lift reporting:
					</div>
					<div>
						<ul class="lift_stats_list">
							<li>- Campaign must have the pixel placed and firing on the website</li>
							<li>- Campaign must run for 3 consecutive months</li>
							<li>- Campaign must run at least 50,000 audience extension impressions per month</li>
						</ul>
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</div>
